import keys from 'lodash/keys';
/**
 * GraphQL Query Builder
 * @param String args.type - { query, mutation }
 * @param String args.operation
 * @param String[] args.properties
 * @param Object args.data
 * @param Object args.variables
 */
export function queryBuilder(args) {
    const type = args.type ? args.type : 'query';
    const operation = args.operation ? args.operation : '';
    const properties = args.properties ? args.properties : [];
    const data = args.data ? args.data : {};
    const variables = args.variables ? args.variables : {};
    return {
        query: `\n
      ${type} ${operation}${mapType(data)} {
        ${operation}${mapArgument(data)} {
        ${properties.join('\n')}
      }
    }\n`,
        variables: Object.assign(Object.assign({}, data), variables),
    };
}
function mapArgument(data = {}) {
    return keys(data).length
        ? `(${keys(data).reduce((dataString, key, i) => {
            return `${dataString}${i !== 0 ? ' ' : ''}${key}: $${key}`;
        }, '')})`
        : '';
}
function mapType(data) {
    return keys(data).length
        ? `(${keys(data).reduce((dataString, key, i) => {
            return `${dataString}${i !== 0 ? ', ' : ''}$${key}: ${queryDataType(data[key])}`;
        }, '')})`
        : '';
}
function queryDataType(data) {
    switch (typeof data) {
        case 'object':
            /* eslint-disable no-underscore-dangle */
            const type = data._type;
            delete data._type;
            return type;
        case 'boolean':
            return 'Boolean';
        case 'number':
            return data % 1 === 0 ? 'Int' : 'Float';
        case 'string':
        default:
            return 'String';
    }
}
